import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "update",
  "use": "update-usage",
  "viewBox": "0 0 20 19.41",
  "content": "<symbol viewBox=\"0 0 20 19.41\" id=\"update\"><defs><symbol id=\"update_ico-update\" data-name=\"ico-update\" viewBox=\"0 0 10 9.7\"><path d=\"M9.4,5.07A4.41,4.41,0,0,0,6,1a.24.24,0,0,0-.11.48,3.92,3.92,0,0,1,3,3.61.24.24,0,0,0,.49,0Zm-5.63-4a4.41,4.41,0,0,0-3,5.48.24.24,0,1,0,.47-.14A3.92,3.92,0,0,1,3.9,1.54a.24.24,0,1,0-.14-.47ZM1.91,8.44a4.41,4.41,0,0,0,6.36-.19.24.24,0,0,0-.36-.33,3.92,3.92,0,0,1-5.66.17.24.24,0,0,0-.34.35Zm0,0\" /><path d=\"M4.85,2.57A1.28,1.28,0,1,0,3.57,1.28,1.28,1.28,0,0,0,4.85,2.57Zm0-.49a.8.8,0,1,1,.8-.8.8.8,0,0,1-.8.8Zm0,0\" /><path d=\"M1.28,8.81A1.28,1.28,0,1,0,0,7.53,1.28,1.28,0,0,0,1.28,8.81Zm0-.49a.8.8,0,1,1,.8-.8.8.8,0,0,1-.8.8Zm0,0\" /><path d=\"M8.72,8.51A1.28,1.28,0,1,0,7.43,7.23,1.28,1.28,0,0,0,8.72,8.51Zm0-.49a.8.8,0,1,1,.8-.8.8.8,0,0,1-.8.8Zm0,0\" /></symbol></defs><title>update</title><use width=\"10\" height=\"9.7\" transform=\"translate(0 0) scale(2)\" xlink:href=\"#update_ico-update\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/update.svg
// module id = +hax
// module chunks = 264